import * as React from "react"
import {
  Edit,
} from "react-admin"
import PrintingMethodForm from "./PrintingMethodForm"

const PrintingMethodTitle = () => {
  return <span>{'印製方式'}</span>
}

const PrintingMethodEdit = () => {
  return (
    <Edit 
      title={<PrintingMethodTitle/>} 
      redirect={false} 
      mutationMode="optimistic"
    >
      <PrintingMethodForm 
        formType="edit" 
      />
    </Edit>
  )
}

export default PrintingMethodEdit